export default __webpack_public_path__ + "static/media/package-8.f3ee10b2.svg";